import { fetchApi } from '@/config/axiosSetting';
import { SignatureQueryParamsType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';

export const postInitialVisitSignatureQueryFunction = (
  params: Omit<SignatureQueryParamsType, 'damagedId'>,
): Promise<{}> => {
  return fetchApi({
    method: 'post',
    url: `/initial/reports/${params?.id}/images/signature/`,
    data: params.data,
  });
};
